import { useCallback, useMemo } from 'react';
import { useAppSelector } from '../store/hooks';
import { disabledEntityTypesOf } from './coreItems';
import { getEntityShortNameByFqn } from '../entityRegistry/entityRegistry';

const NONE: readonly string[] = [];

/**
 * Le voci del core spente sulla company (FILO-53), da `user.disabledCoreItems`. Assente (utente non
 * ancora caricato, backend precedente, mock) vale «tutte accese».
 */
export function useDisabledCoreItems(): ReadonlySet<string> {
  const keys = useAppSelector((state) => state.auth.user?.disabledCoreItems ?? NONE);
  return useMemo(() => new Set(keys), [keys]);
}

/** I tipi di record delle voci spente: spariscono da tutta l'interfaccia. */
export function useDisabledEntityTypes(): ReadonlySet<string> {
  const disabled = useDisabledCoreItems();
  return useMemo(() => disabledEntityTypesOf(disabled), [disabled]);
}

/**
 * Vero se il FQN è di un tipo spento: per le liste che arrivano dal server con il `className`
 * (board, pipeline, automazioni, modelli), che altrimenti mostrerebbero i record di quel tipo.
 */
export function useIsClassNameDisabled(): (className: string | undefined) => boolean {
  const disabledTypes = useDisabledEntityTypes();
  return useCallback(
    (className) => {
      const typeName = className ? getEntityShortNameByFqn(className) : undefined;
      return typeName !== undefined && disabledTypes.has(typeName);
    },
    [disabledTypes],
  );
}

export function useIsCoreItemEnabled(key: string): boolean {
  return !useDisabledCoreItems().has(key);
}
